<div class="dialog-wrap">
  <p>{{data.text}}</p>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="confirm()">{{"CONFIRM_MODAL.CONFIRM" | translate}}</button>
    <button mat-raised-button color="warn" (click)="close()">{{"CONFIRM_MODAL.CLOSE" | translate}}</button>
  </div>
</div>
